import {
  integerFormatter,
  nullFormatter,
} from "../../gridFormatters";


export const switchSummaryDefs = [
  {
    "field": "port_name",
    "headerName": "Port Num",
    "enableRowGroup": true
  },
  {
    "field": "port_alias",
    "headerName": "Host Port Alias",
    "enableRowGroup": true,
  },
  {
    "field": "sfp_present",
    "headerName": "SFP Present",
    "enableRowGroup": true,
  },
  {
    "field": "port_is_licensed",
    "headerName": "Port Licensed",
    "enableRowGroup": true,
  },
  {
    "field": "current_speed",
    "headerName": "Port Speed",
    "enableRowGroup": true,
  },
  {
    "field": "port_sn",
    "headerName": "Port Serial Number",
    "enableRowGroup": true,
  },
  {
    "field": "mapped_port",
    "headerName": "Aliases on Port",
    "enableRowGroup": true,
  },
  {
    "field": "port_errors",
    "headerName": "Error Count on Port",
    "enableRowGroup": true,
    "type": "numericColumn",
    "cellRenderer": integerFormatter,
    "cellStyle": {
      "text-align": "center"
    },
    "aggFunc": "sum"
  },
  {
    "field": "port_error_type",
    "headerName": "Top Error Type",
    "enableRowGroup": true,
  },
  {
    "field": "device_wwn",
    "headerName": "Mapped wwn",
    "enableRowGroup": true
  },
  {
    "field": "port_internal_name",
    "headerName": "Port Internal Name",
    "enableRowGroup": true,
  },
    {
    "field": "port_type",
    "headerName": "Port Type",
    "enableRowGroup": true,
    "cellRenderer": nullFormatter,
  },
];